import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import MainContainer from './MainContainer/MainContainer';

class App extends Component {
  render() {
    return (
      <div><MainContainer /></div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js